export function safeJsonParse(value: string | undefined | null, fallback: object = {}): any {
    try {
        if (!value) return fallback;
        return JSON.parse(value);
    } catch {
        return fallback;
    }
}
